import React, { useState, useRef, useEffect } from 'react';
import clsx from 'clsx';
import { observer } from 'mobx-react';
import SportsTeamLogo from 'components/teamLogo';
//import { _SPORTS_STATUS } from 'common/constants/sportsConstants';
import style from './style.module.scss';
import MajorViewOdds from '../odds';
import TextLengthTooltip from 'components/textLengthTooltip';
import { FormatUtil } from 'utils/formatUtil';
import useStore from '../../../../../hooks/useStore';
import { v4 as uuidv4 } from 'uuid';
import Banner from '../../../../../components/banner';
import { _SPORTS_TYPE } from '../../../../../common/constants/sportsConstants';
import { getStreamBrowser } from '../../../liveStream/util';
import moment from 'moment/moment';

const MajorViewList = observer(({ item, isSelected, setSelectedGame }) => {
  const {
    id,
    getTeamData,
    league,
    startDatetime,
    getStartDateTime,
    statusText,
    teams,
    getTracker,
    //    betbleUri,
    videoLink,
    sportsType,
    gameStatus,
    oddsData,
    goalEvent,
    volleyBallPeriodScore,
    winnerTeam,
    //    betbleButtonVisible,
    cheerCount,
  } = item;
  const oddsOpenButtonRef = useRef();
  const [isOddsOpen, toggleOddsOpen] = useState(false);
  const { bannerStore } = useStore();
  const formattedStartDateTime = moment(startDatetime).format('HH:mm');

  const itemId = useRef(uuidv4()).current;
  useEffect(() => {
    if (!bannerStore.activeMajorViewId || bannerStore.activeMajorViewId === 'placeholder') {
      bannerStore.setActiveMajorView(itemId, _SPORTS_TYPE.MAJOR);
    }
  }, [itemId, bannerStore, bannerStore.activeMajorViewId]);

  //  const onClickBetble = (event) => {
  //    event.stopPropagation();
  //    let type = 0;
  //
  //    if (_SPORTS_STATUS[gameStatus] === 1) {
  //      type = 1;
  //    }
  //
  //    const url = `https://betble.com/game/game.php?type=${type}${betbleUri}`;
  //
  //    window.open(url);
  //  };

  // const onClickVideo = (event) => {
  //   event.stopPropagation();
  //
  //   window.open(
  //     videoLink,
  //     `video_${id}`,
  //     "width=980px,height=750px,scrollbars=yes"
  //   );
  // };

  const onClickVideo = (event) => {
    event.stopPropagation();
    getStreamBrowser(videoLink);
  };

  const onClickNewWindow = (event) => {
    event.stopPropagation();
    let type = sportsType.toLowerCase();

    if (type === 'icehockey') {
      type = 'hockey';
    }

    window.open(
      `/match/${type}/${item.id}?20210308`,
      `detail_${type}_${item.id}`,
      'width=1000px,height=901px,scrollbars=yes'
    );
  };

  const setSelectedItem = (event) => {
    event.stopPropagation();

    setSelectedGame(isSelected, id, startDatetime, gameStatus, sportsType);
  };
  //  console.log(bannerStore.activeMajorViewId)

  return (
    <>
      <a className={style.score_board} onClick={onClickNewWindow}>
        <div className={style.summary_score}>
          {/*헤더 */}
          <div className={clsx(style.info, style[getTracker.class])}>
            <TextLengthTooltip
              name={league.shortName}
              className={clsx(style.league, style[sportsType.toLowerCase()])}
              maxLength={8}
            />
            <span className={style.time}>{formattedStartDateTime}</span>
            <span className={style.state}>{statusText}</span>

            {/*<span>{itemId}</span>*/}
          </div>

          {/* 팀 */}
          <div className={style.team_area}>
            <div
              className={clsx(
                style.team,
                style.away,
                goalEvent.isActive && goalEvent.location === 'away' && style.highlight
              )}
            >
              <div className={style.name}>
                <TextLengthTooltip name={getTeamData.away.name} className={''} maxLength={8} />
              </div>
              <div className={style.logo}>
                <SportsTeamLogo imgSize={'25'} imgUrl={!!teams ? teams.away.imgPath : null} isLazy={true} />
              </div>
              <div
                className={clsx(
                  style.point,
                  winnerTeam.activeScore === 'away' && style.on,
                  typeof getTeamData.away.score === 'string' && style.blank
                )}
              >
                {sportsType === 'VOLLEYBALL' ? (
                  <>
                    {getTeamData.away.score}
                    {gameStatus === 'IN_PROGRESS' && <span>({volleyBallPeriodScore.away.score})</span>}
                  </>
                ) : (
                  getTeamData.away.score
                )}
                {sportsType === 'SOCCER' && getTeamData.isPk && <span>({getTeamData.away.pkScore})</span>}
                {sportsType === 'ICEHOCKEY' && getTeamData.isShootout && (
                  <span>({getTeamData.away.shootoutScore})</span>
                )}
              </div>
            </div>
            <div
              className={clsx(
                style.team,
                style.home,
                goalEvent.isActive && goalEvent.location === 'home' && style.highlight
              )}
            >
              <div className={style.logo}>
                <SportsTeamLogo imgSize={'25'} imgUrl={!!teams ? teams.home.imgPath : null} isLazy={true} />
              </div>
              <div className={style.name}>
                <TextLengthTooltip name={getTeamData.home.name} className={''} maxLength={8} />
              </div>
              <div
                className={clsx(
                  style.point,
                  winnerTeam.activeScore === 'home' && style.on,
                  typeof getTeamData.home.score === 'string' && style.blank
                )}
              >
                {sportsType === 'SOCCER' && getTeamData.isPk && <span>({getTeamData.home.pkScore})</span>}
                {sportsType === 'ICEHOCKEY' && getTeamData.isShootout && (
                  <span>({getTeamData.home.shootoutScore})</span>
                )}
                {sportsType === 'VOLLEYBALL' ? (
                  <>
                    {gameStatus === 'IN_PROGRESS' && <span>({volleyBallPeriodScore.home.score})</span>}
                    {getTeamData.home.score}
                  </>
                ) : (
                  getTeamData.home.score
                )}
              </div>
            </div>
          </div>

          {/* 버튼 */}
          <div className={style.btn_area}>
            {/*{betbleButtonVisible && (*/}
            {/*  <button*/}
            {/*    className={clsx(style.btn, style.betting)}*/}
            {/*    title="베팅하기"*/}
            {/*    onClick={onClickBetble}*/}
            {/*  >*/}
            {/*    베팅*/}
            {/*  </button>*/}
            {/*)}*/}
            {!!videoLink && (gameStatus === 'IN_PROGRESS' || gameStatus === 'BREAK_TIME' || gameStatus === 'PAUSE') && (
              <button className={clsx(style.btn, style.onair)} title='생중계' onClick={onClickVideo}>
                생중계
              </button>
            )}
            <button className={clsx(style.btn_ud, isSelected ? style.down : style.up)} onClick={setSelectedItem}>
              올리기/내리기
            </button>
          </div>

          {/* 배당 정보 */}
          {isOddsOpen && (
            <MajorViewOdds
              oddsData={oddsData}
              team={getTeamData}
              closeOdds={toggleOddsOpen}
              oddsOpenButtonRef={oddsOpenButtonRef}
              isTimeView
            />
          )}

          {cheerCount >= 100 && <div className={style.cheer_count}>{FormatUtil.numberUnitConvert(cheerCount)}</div>}
        </div>
      </a>
      {bannerStore.activeMajorViewId === itemId ? <Banner borderBottom='1px solid #eceff3' /> : null}
    </>
  );
});

export default MajorViewList;
